import React from "react";

function BoardDirectors() {
    const directors = [
        {
            name: "Chairman",
            designation: "Tamilnadu Warehousing Corporation",
            location: "Chennai.",
        },
        {
            name: "Thiru.A.John Louis, I.A.S.",
            designation: "Managing Director, Tamil Nadu Warehousing Corporation",
            location: "Chennai.",
        },
        {
            name: "Tmt. Shilpa Prabhakar Satish, I.A.S.",
            designation:
                "Managing Director, Tamil Nadu Civil Supplies Corporation Ltd.",
            location: "Chennai.",
        },
        {
            name: "Tmt.G.Latha, I.A.S.",
            designation: "Registrar of Co-op. Societies",
            location: "Chennai.",
        },
        {
            name: "Thiru.R.Ramanathan",
            designation:
                "Joint Secretary to Government, Finance Department",
            location: "Chennai.",
        },
        {
            name: "Thiru.P.B.Saravanakumar",
            designation:
                "Joint Secretary to Government, Co-operation, Food and Consumer Protection Dept.",
            location: "Chennai.",
        },
        {
            name: "Ms. Priya Jacob",
            designation:
                "Director (Logistics, IEC / Social Media, Storage-II, Movement), Ministry of Consumer Affairs, Food & Public Distribution",
            location: "Govt. of India, New Delhi",
        },
        {
            name: "Shri. Samuel Praveen Kumar",
            designation:
                "Director (Marketing & Corporate Planning), Corporate Office, Central Warehousing Corporation",
            location: "New Delhi.",
        },
        {
            name: "Shri.J.Navukkarasu",
            designation: "Regional Manager, Central Warehousing Corporation",
            location: "Chennai.",
        },
        {
            name: "Shri. Jagadeeswar Karri",
            designation: "Deputy General Manager(ABU&GSS) State Bank of India,",
            location: "Chennai.",
        },
        {
            name: "Thiru. Maharajan Arumugam",
            designation: " Non Official Director",
            location: "Tirunelveli.",
        },
    ];

    return (
        <div className="container py-4 py-md-5">
            {/* Page Heading */}
            <div className="text-center mb-4 mb-md-5">
                <div className="d-inline-flex align-items-center gap-2">
                    <span
                        className="bg-danger rounded-pill"
                        style={{ width: "5px", height: "32px" }}
                    ></span>

                    <h2 className="fw-bold text-dark mb-0">
                        Board of Directors
                    </h2>
                </div>

                <p className="text-muted mt-2 mb-0">
                    Tamil Nadu Warehousing Corporation
                </p>
            </div>

            {/* Directors */}
            <div className="row g-4">
                {directors.map((director, index) => (
                    <div className="col-12 col-md-6" key={index}>
                        <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                            {/* Top Accent */}
                            <div
                                style={{
                                    height: "5px",
                                    background:
                                        "linear-gradient(90deg, #dc3545, #ff7a85)",
                                }}
                            ></div>

                            <div className="card-body p-4">
                                <div className="d-flex align-items-center gap-3">
                                    {/* Serial Number */}
                                    <div
                                        className="d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle fw-bold text-white"
                                        style={{
                                            width: "42px",
                                            height: "42px",
                                            backgroundColor: "#dc3545",
                                        }}
                                    >
                                        {index + 1}
                                    </div>

                                    {/* Content */}
                                    <div>
                                        <h5 className="fw-bold text-dark mb-1">
                                            {director.name}
                                        </h5>

                                        <div className="text-danger fw-semibold small mb-2">
                                            {index === 0
                                                ? "Chairman"
                                                : index === 1
                                                    ? "Managing Director"
                                                    : "Director"}
                                        </div>

                                        <p className="text-secondary mb-1 lh-base">
                                            {director.designation}
                                        </p>

                                        <small className="text-muted">
                                            <i className="bi bi-geo-alt-fill me-1"></i>
                                            {director.location}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BoardDirectors;